require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-visual-design-make-a-css-heartbeat-using-an-infinite-animation-count.json") })
        }
      }, "path---responsive-web-design-applied-visual-design-make-a-css-heartbeat-using-an-infinite-animation-count");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-visual-design-make-a-css-heartbeat-using-an-infinite-animation-count!./.cache/json/responsive-web-design-applied-visual-design-make-a-css-heartbeat-using-an-infinite-animation-count.json
// module id = 2565
// module chunks = 231608221292675